'use strict';
import angular from 'angular';
import _ from 'lodash';

angular.module('task.services', ['core.iohelper'])
    .factory('TasksFactory', TasksFactory)
    .factory('TaskDataGridFactory', TaskDataGridFactory);

/**
 * @ngInject
 */
function TasksFactory(
    Restangular,
    ColumnValueType
) {
    var tasks = Restangular.all('tasks');
    var vars = tasks.one('vars');
    var values = tasks.one('values');

    /**
     *
     * @param queryParams
     * @returns {*|ICollectionPromise<T>|ICollectionPromise<any>|{method, params, headers}}
     */
    function getColumns(queryParams) {
        return tasks.getList(_.extend({
            metadata: true,
            sort: 'label'
        }, queryParams));
    }

    /**
     * Get all selectable values for specific fields (enum values)
     * @param fields (fields can be undefined to fetch all)
     * @returns {*}
     */
    function getColumnValues(fields) {
        return values.one(ColumnValueType.SET).get(_.isUndefined(fields) ? '' : {fields: fields});
    }

    /**
     * Get all distinct values for specific fields
     * @param fields (fields can be undefined to fetch all)
     * @dataSource unused
     * @queryParams any additional query params
     * @returns {*}
     */
    function getFieldValues(fields, dataSource, queryParams) {
        return values.one(ColumnValueType.DISTINCT).get(
            _.extend(_.isUndefined(fields) ? {} : {fields: fields}, queryParams || {}));
    }

    /**
     * Get data for this resource
     * @param queryParams
     * @returns {*|ICollectionPromise<any>|ICollectionPromise<T>|{method, params, headers}}
     */
    function getData(queryParams) {
        return tasks.getList(queryParams);
    }

    return {
        tasks: tasks,
        vars: vars,
        getColumns: getColumns,
        getColumnValues: getColumnValues,
        getFieldValues: getFieldValues,
        getData: getData
    }
}

/**
 *
 * @ngInject
 */
function TaskDataGridFactory(
    IODefaultLinkColumns,
    IODefaultLinkColumnsRenderer,
    TaskColumns,
) {
    return {
        getDTOptions: getDTOptions
    };

    /**
     * Return service specific datatable options
     * @returns {{}}
     */
    function getDTOptions() {
        var dtOptions = {};
        dtOptions.customRenders = {};
        dtOptions.customRenders[TaskColumns.ID] = IODefaultLinkColumnsRenderer.renderIoTaskLinkColumn;
        dtOptions.customRenders[IODefaultLinkColumns.FLIGHT_ID] = IODefaultLinkColumnsRenderer.renderIoFlightLinkColumn
        dtOptions.customRenders[IODefaultLinkColumns.LINE_ITEM_ID] = IODefaultLinkColumnsRenderer.renderIoLineItemLinkColumn;
        dtOptions.customRenders[IODefaultLinkColumns.ORDER_ID] = IODefaultLinkColumnsRenderer.renderIoOrderIdLinkColumn;
        return dtOptions;
    }
}